<template>
  <div class="minha-conta" :style="cobrancas.length == 0 ? 'height:100vh' : ''">
    <header class="bg-dark py-2">
      <div class="container">
        <div class="row">
          <div class="col">
            <router-link to="/">
              <img src="/img/logo.svg" width="150" height="34" />
            </router-link>
            <span class="badge badge-success ml-2">admin</span>
          </div>

          <div class="col text-right">
            <SideNav />
          </div>
        </div>
      </div>
    </header>
    <div class="bg-gradient">
      <div class="container text-center pt-3">
        <h3>Análise Cobranças</h3>
        <div class="h-line" style="width:142px;"></div>
      </div>
    </div>

    <div class="container mt-5 pb-5">
      <div class="row mb-4">
        <div class="col-md-4 mb-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                Nome
              </span>
            </div>
            <input type="text" class="form-control" v-model="nome" />
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                Telefone
              </span>
            </div>
            <input type="text" class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" v-model="telefone" />
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                CPF
              </span>
            </div>
            <input type="text" class="form-control" v-mask="'###.###.###-##'" v-model="cpf" />
          </div>
        </div>
        <div class="col-md-4 mb-2">
          <div class="input-group">
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">Status</span>
            </div>

            <b-form-select v-model="tipoAssinatura">
              <option :value="null">Todos </option>
              <option :value="config.ID_TIPO_ASSINATURA_MENSAL">Mensal</option>
              <option :value="config.ID_TIPO_ASSINATURA_ANUAL">Anual </option>
            </b-form-select>
          </div>
        </div>

        <div class="col-md-4 mb-2">
          <button type="submit" class="btn btn-success btn-block mb-3" @click.prevent="buscarCobrancas()"
            :disabled="loading">
            <span v-if="!loading">Buscar cobrança</span>
            <span v-if="loading">Por favor aguarde...</span>
          </button>
        </div>
      </div>
    </div>

    <div style="padding-bottom:20px">
      <div class="overflow-auto box-one" v-show="cobrancas.length > 0">
        <div v-if="selected.length > 0">
          <div class="text-right mt-3">
            <b-button variant="success" class="mr-4" @click="showModalMensagem = true">Mensagem</b-button>
            <b-button variant="success" @click="abrirModalAnaliseCobranca(null)">FeedBack</b-button>
          </div>
        </div>
        <b-table
          id="cobrancas-table"
          hover
          :items="cobrancas"
          :fields="fields"
          :per-page="perPage"
          :current-page="currentPage"
          small
        >
          <!-- <template #cell(select)="data">
            <b-form-checkbox v-model="selected" :value="data.item"></b-form-checkbox>
          </template> -->
          <template #cell(idFatura)="data">
            <a @click="buscarLinkFatura(data.item.idFatura, data.item.urlFatura)" href="javascript:void(0);">
              <span v-if="loadingFatura !== null && loadingFatura === data.item.idFatura">Buscando...</span>
              <span v-else>Buscar Fatura</span>
            </a>
          </template>
          <template #cell(idCobranca)="data">
            <div style="position:relative; display:inline-block;">
              <b-badge class="badge-custtom" v-if="data.item.quantidade > 0" variant="success">{{
                data.item.quantidade
              }}</b-badge>
              <b-badge class="badge-custtom" v-if="data.item.erroEnvioMensagem" variant="danger">Mensagem não enviada</b-badge>
              <b-button variant="success" size="sm" @click="abrirModalAnaliseCobranca(data.item.idCobranca)">
                <i class="fas fa-plus fa-fw"></i>
              </b-button>
            </div>
          </template>
          <template #cell(historico)="data">
            <b-button variant="success" size="sm" @click="abrirHistorico(data.item.idCobranca)">
              <i class="fa fa-list"></i>
            </b-button>
          </template>
        </b-table>
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          pills
          aria-controls="cobrancas-table"
        ></b-pagination>
      </div>
    </div>
    <div>
      <Loading :criandoSeguro="true" v-if="loading" />
      <ModalHistoricoCobranca :showModalHistorico="showModalHistorico" :idCobranca="idCobranca"
        @hide="fecharModalHistorico" />
      <ModalAnaliseCobranca :selected="selected" :showModal="showModal" :idCobranca="idCobranca"
        @hide="fecharModalAnaliseCobranca" @hideModalF="fecharModalAnaliseCobrancaVarios" />
      <ModalMensagem :selected="selected" :showModal="showModalMensagem" :idCobranca="idCobranca"
        @hide="fecharModalMensagem" />
    </div>
  </div>
</template>

<script>
import SideNav from "../../components/Admin/SideNav";
import config from "../../config";
import auth from "../../auth";
import Swal from "sweetalert2";
import axios from "axios";
import formatacaoMoeda from "../../helpers/formatacaoMoeda";
import formatacaoData from "../../helpers/formatacaoData";
import formatacaoTelefone from "../../helpers/formatacaoTelefone";
import helper from "../../helpers/helper";
import ModalHistoricoCobranca from "../../components/Admin/ModalHistoricoCobranca.vue";
import ModalAnaliseCobranca from "../../components/Admin/ModalAnaliseCobranca.vue";
import ModalMensagem from "../../components/Admin/ModalMensagem.vue";
import Loading from "../../components/Usuario/Loading.vue";
export default {
  components: {
    SideNav,
    ModalHistoricoCobranca,
    ModalAnaliseCobranca,
    ModalMensagem,
    Loading,
  },
  data() {
    return {
      config,
      loading: false,
      cobrancas: [],
      selected: [],
      idUsuarioAdm: undefined,
      formatacaoMoeda,
      formatacaoData,
      formatacaoTelefone,
      nome: null,
      email: null,
      telefone: null,
      tipoAssinatura: null,
      cpf: null,
      helper,
      loadingText: false,
      loadingFatura: null,
      showModalMensagem: false,
      //Modal
      showModalHistorico: false,
      idCobranca: undefined,

      showModal: false,

      fields: [
        // {
        //   key: "select",
        //   label: "",
        //   sortable: false,
        //   thClass: "text-center",
        //   tdClass: "text-center",
        // },
        {
          key: "tipoAssinatura",
          label: "Assinatura",
          sortable: true,
        },
        {
          key: "dataCriado",
          label: "Data Vencido",
          sortable: true,
          formatter: (value) => formatacaoData.formatarDataHoraLocal(value),
        },
        {
          key: "nome",
          label: "Nome",
          sortable: true,
        },
        {
          key: "email",
          label: "E-mail",
        },
        {
          key: "cpf",
          label: "CPF",
          formatter: (value) => helper.formatacaoCpf(value),
        },
        {
          key: "telefone",
          label: "Telefone",
          formatter: (value) => formatacaoTelefone(value),
        },
        {
          key: "valor",
          label: "Valor",
          sortable: true,
          formatter: (value) =>
            "R$ " +
            value?.toLocaleString("pt-BR", {
              maximumFractionDigits: 2,
              minimumFractionDigits: 2,
            }),
        },
        {
          key: "idFatura",
          label: "Fatura",
        },
        {
          key: "idCobranca",
          label: "Ações",
        },
        {
          key: "historico",
          label: "Histórico",
        },
      ],
      currentPage: 1,
      perPage: 10,
    };
  },
  created() {
    var userInfo = auth.getUserInfo();
    if (userInfo && userInfo.cargo) {
      this.idUsuarioAdm = userInfo.id;
    } else {
      this.$router.replace("/login");
    }
  },
  mounted() {
    this.buscarCobrancas();
  },
  computed: {
    rows() {
      return this.cobrancas.length;
    },
  },
  methods: {
    ordenarMaiorValor() {
      this.cobrancas.sort((a, b) => a.valor - b.valor);
    },
    ordenarMenorValor() {
      this.cobrancas.sort((a, b) => b.valor - a.valor);
    },
    fecharModalHistorico() {
      this.showModalHistorico = false;
    },
    abrirHistorico(item) {
      this.showModalHistorico = true;
      this.idCobranca = item;
    },
    abrirModalAnaliseCobranca(item) {
      this.showModal = true;
      this.idCobranca = item;
    },
    fecharModalAnaliseCobranca(value) {
      this.showModal = false;
      if (value?.modificou) {
        this.cobrancas.forEach(element => {
          if (element.idCobranca === value.idCobranca) {
            element.quantidade++;
          }
        });
      }
    },
    fecharModalAnaliseCobrancaVarios(values) {
      this.showModal = false;
      if (values?.modificou) {
        this.cobrancas.forEach(element => {
          if (values.cobrancas.find(w => w.idCobranca == element.idCobranca)) {
            element.quantidade++;
          }
        });
        this.selected = [];
      }
    },
    fecharModalMensagem(values) {
      this.showModalMensagem = false;

      if (values?.modificou) {
        this.cobrancas.forEach(element => {
          const cobranca = values.cobrancas.find(w => w.idCobranca == element.idCobranca);
          if (cobranca != null) {
            element.quantidade++;
            element.erroEnvioMensagem = cobranca.erroEnvioMensagem;
          }
        });
        this.selected = [];
      }
    },
    async buscarCobrancas() {
      var data = {
        email: this.email,
        nome: this.nome,
        telefone: this.telefone,
        cpf: this.cpf,
        tipoAssinatura: this.tipoAssinatura,
      };

      this.loading = true;
      try {
        var response = await axios.post(
          `${config.API_URLV2}/AnaliseCobranca/Buscar`,
          data
        );

        if (response.data.length === 0) {
          Swal.fire({
            icon: "warning",
            title: "Oops...",
            html: `Não foi encontrada nenhuma cobrança para essa pesquisa`,
          });
        }

        this.cobrancas = response.data;
        this.selected = [];

        this.loading = false;
      } catch (error) {
        this.loading = false;
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text:
            "Não foi possível consultar as cobranças. Tente novamente mais tarde ou contate o suporte.",
        });
      }
    },
    async buscarLinkFatura(idFaturaIugu, urlFatura) {
      if (urlFatura) {
        window.open(urlFatura, "_blank");
        return;
      }

      this.loadingFatura = idFaturaIugu;
      try {
        var link = await axios.get(
          `${config.API_URLV2}/CobrancaSeguro/BuscarLinkFatura/${idFaturaIugu}`
        );

        window.open(link.data, "_blank");
      } catch (error) {
        this.$toast.error("não foi possivel buscar a fatura");
      } finally {
        this.loadingFatura = null;
      }
    },
  },
};
</script>
<style>
.table th {
  vertical-align: top;
  border-top: 1px solid #ffffff;
}
.table-sm th,
.table-sm td {
  padding: 1rem;
}
</style>
<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&display=swap");

.box-one {
  border-radius: 12px;
  cursor: pointer;
  text-align: center;
  padding: 10px;
  margin-left: 20px;
  margin-right: 20px;
  box-shadow: 0 6px 10px -4px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  color: #252422;
  margin-bottom: 20px;
  position: relative;
  border: 0;
  transition: box-shadow 0.2s ease,
    -webkit-transform 0.3s cubic-bezier(0.34, 2, 0.6, 1);
  transition: transform 0.3s cubic-bezier(0.34, 2, 0.6, 1), box-shadow 0.2s ease;
  transition: transform 0.3s cubic-bezier(0.34, 2, 0.6, 1), box-shadow 0.2s ease,
    -webkit-transform 0.3s cubic-bezier(0.34, 2, 0.6, 1);
}

.retangulo-flutuante {
  position: fixed;
  bottom: 30px;
  right: 30px;
}

.display-inline-grid {
  display: inline-grid;
  cursor: pointer;
}

.margin-5 {
  margin: 5px;
}

.display-inline-flex {
  display: inline-flex;
}

.minha-conta {
  font-family: "Montserrat";
  background-color: #f4f3ef;
  transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
}

.bg-gradient {
  background: rgb(0, 0, 0);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0.14609593837535018) 0%,
    rgba(255, 255, 255, 0) 70%
  );
}

.pagination {
  justify-content: center;
}

.icone-principal {
  font-size: 43px;
  color: #28a745;
  background: -webkit-linear-gradient(#76b566, #28a745);
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.not-collapsed .when-closed,
.collapsed .when-open {
  display: none;
}

.item {
  position: relative;
  padding-top: 20px;
  display: inline-block;
}

.badge-custtom {
  position: absolute;
  right: 3px;
  top: -6px;
  text-align: center;
  color: white;
  padding: 2px 5px;
  font-size: 7px;
}

.margin-row {
  margin: 0px;
}

@media (max-width: 1199px) {
  .badge-custtom {
    position: absolute;
    right: -6px;
    top: -6px;
    text-align: center;
    color: white;
    padding: 2px 5px;
    font-size: 7px;
  }
}

.end-justify {
  justify-content: end;
}

@media (max-width: 991px) {
  .margin-row {
    margin-left: -10px;
    margin-right: -10px;
  }

  .badge-custtom {
    position: absolute;
    right: -12px;
    top: -5px;
    text-align: center;
    color: white;
    padding: 2px 5px;
    font-size: 7px;
  }
}
</style>
